import { Action } from '@ngrx/store';
import { NoteInterface } from '../../models/note.interface';

export enum EDisplayNotesActions {
  UpdateDisplayNotesVisibility = '[DISPLAY_NOTES] Hide/Display notes'
}

export class UpdateDisplayNotesVisibility implements Action {
  public readonly type = EDisplayNotesActions.UpdateDisplayNotesVisibility;
  constructor(public payload: NoteInterface|null) {}
}

export type DisplayNotesActions = UpdateDisplayNotesVisibility;
